import React from "react";
import './AboutUs.css';
import LogoDropDown from "../LogoDropDown/logoDropDown";
import CTAButton from "../utils/Button/CTAButton";

const showDebugLines = false;

function AboutUsClub() {
    return (
        <div className="about-us-container">
            <div className='about-us-header'>
                <LogoDropDown activeItems={[".club"]}/>
            </div>
            <div className="about-us-main">

                A private members’ club, empowering <br/>
                fashion & beauty icons to expand their <br/>
                <p style={{ fontFamily: 'Playfair Display', fontWeight: 400 }}>
                    potential and be more than <i style={{ fontFamily: 'Playfair Display', fontWeight: 400 }}>just a model</i>.
                </p>
                <br/>
                We are a global community who<br/>
                <span style={{ fontFamily: 'Playfair Display', fontWeight: 700 }}>connect, collaborate & create</span>
                value through lasting partnerships.<br/>
                No agency. Just community.<br/>
                <br/>
                Membership also gives you access to <br/>
                <p style={{ fontFamily: 'Playfair Display', fontWeight: 400 }}>
                    <span
                        style={{ fontFamily: 'Playfair Display', fontWeight: 400, color: "#B08D57", cursor: "pointer" }}
                        onClick={() => window.location.href = `${process.env.REACT_APP_SHOP_URL}/aboutus`}
                    >Schmodel.Shop</span>.
                </p>
            </div>
            <div
                className="about-us-footer"
            >
                <div style={{ width: '100%', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    {showDebugLines && (
                        <div className="debug-lines">
                            <div className="debug-line debug-line-left"></div>
                            <div className="debug-line debug-line-right"></div>
                        </div>
                    )}
                    {/* Center apply button in available space between text and footer*/}
                    <CTAButton
                        onClick={() => window.location.href = `${process.env.REACT_APP_CLUB_URL}/memberships`}
                        text={'Apply'}
                    />
                </div>
                <p
                    style={{
                        color: '#B08D57',
                        fontFamily: 'Playfair Display',
                        fontWeight: 800,
                        fontSize: 'clamp(14px, 2.8vh, 20px)',
                        lineHeight: 0.9
                    }}
                >
                    Not just a model.
                </p>
            </div>
        </div>
    );
}

export default AboutUsClub;
